import "react-app-polyfill/ie9"; // For IE 9-11 support
import "react-app-polyfill/ie11"; // For IE 11 support
import "react-picky/dist/picky.css";
import "react-toastify/dist/ReactToastify.css";
import React from "react";
import App from "./App";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import store from "./redux/store";
import { icons } from "./assets/icons";
import { ToastContainer } from "react-toastify";
import TagManager from "react-gtm-module";
import reportError from "./services/errorReporter";

if (process.env.NODE_ENV !== "production") {
  require("./config/ReactotronConfig");
}

React.icons = icons;

window.addEventListener("error", event => {
  reportError({
    type: "window-error",
    message: event.message,
    stack: event.error && event.error.stack,
  });
});
window.addEventListener("unhandledrejection", event => {
  const reason = event.reason;
  reportError({
    type: "unhandled-rejection",
    message: (reason && reason.message) || String(reason),
    stack: reason && reason.stack,
  });
});

TagManager.initialize({ gtmId: process.env.REACT_APP_GTM_KEY });

ReactDOM.render(
  <Provider store={store}>
    <App />
    <ToastContainer />
  </Provider>,
  document.getElementById("root"),
);

serviceWorker.unregister();
